module.exports = __webpack_public_path__ + "img/RX-RAD-CONVENCIONAL-Moviles-4.c34c9b45.png";